<button
  #borderBtnId
  class="app-btn"
  [disabled]="disabled"
  (click)="onClick()"
  [type]="type"
>
  <span><ng-content></ng-content></span>
</button>
